var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AboutHeader'),_c('b-container',[_c('Hotels'),_c('OurSpace'),_c('Leadership')],1),_c('HowItWorks'),_c('b-container',[_c('CheckIn')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }